import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !["width", "height"].includes(prop),
})(({ width, height, theme }) => ({
  borderRadius: theme.shape.customBorderRadius[3], //25px
  color: theme.palette.primary.white,
  backgroundColor: theme.palette.primary.redPrimary,
  borderColor: theme.palette.primary.redPrimary,
  width,
  height,

  "&:hover": {
    backgroundColor: theme.palette.primary.redSecound,
    borderColor: theme.palette.primary.redSecound,
    color: theme.palette.primary.white,
  },
  "&:active": {
    backgroundColor: theme.palette.primary.redDark,
    borderColor: theme.palette.primary.redDark,
    color: theme.palette.primary.white,
  },
  "&:disabled": {
    backgroundColor: theme.palette.primary.redThird,
    border: `1.5px solid ${theme.palette.primary.redThird}`,
    color: theme.palette.primary.redSecound,
    cursor: "not-allowed",
  },
}));

export const SolidWarnButton = ({
  iconStart,
  iconEnd,
  width,
  height,
  children,
  ...rest
}) => {
  return (
    <StyledButton
      startIcon={iconStart}
      endIcon={iconEnd}
      width={width}
      height={height}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};
